import styled from 'styled-components';

import { FontSizes, FontWeights, minWidth, Text, TextElements } from '@calm-web/design-system';

import LimitedTimeCalloutRaw from '@/components/PreSignupFlow/Components/LimitedTimeCallout';

export const CardPadding = styled.div`
	padding: 20px;
	${minWidth('tablet')} {
		padding: 50px;
	}
`;
export const ProgramDetail = styled(Text).attrs({
	el: TextElements.P,
	color: 'gray5',
	size: FontSizes.sm,
	weight: FontWeights.Medium,
})`
	padding-bottom: 18px;
`;

export const Section = styled.section`
	display: grid;
	grid-template-columns: 1fr;
	max-width: 1168px;
	margin: 40px auto;
	padding: 0 14px;
	gap: 48px;
	align-items: center;
	${minWidth('tablet')} {
		margin: 75px auto;
		grid-template-columns: 1fr 1fr;
	}
`;

export const LimitedTimeCallout = styled(LimitedTimeCalloutRaw)`
	margin: 0;
`;
